import React from 'react'
import AboutUsSection from '../../components/about/AboutUS'
import { useSelector } from 'react-redux'
import Rimg1 from "../../assest/Residentails-1.png";
import Rimg2 from "../../assest/Residental-2.png";
import Rimg3 from "../../assest/Residenatl-3.png";
import ServicesCard from '../../components/home/ServicesCard';
import FaqSection from '../../components/about/FAQ';
import ServicesSubPages from '../residential/ServicesSubPages';

const Infrastructure = () => {
  const language = useSelector((state) => state.language.language) || 'gb';

  const translations = {
    gb: {
      heading: "Our Infrastructure",
      buttonText: "Get In Touch",
      aboutHeading: "About Our Infrastructure Services",
      aboutText: `At Etihad Gharbia Contracting Company, we are committed to shaping the future of Saudi Arabia through world-class infrastructure development. Our infrastructure division delivers critical civil engineering solutions that support urban growth, industrial expansion, and regional connectivity.

From roads and bridges to water networks and utility systems, we execute complex projects with precision, safety, and sustainability in mind. Our expert teams collaborate with government bodies and private clients to ensure timely and budget-conscious delivery of infrastructure essential to the Kingdom's Vision 2030.`,
      includedHeading: "What's Included in Our Infrastructure Services",
      includedItems: [
        "Construction of highways, roads, and bridges",
        "Development of stormwater and drainage systems",
        "Installation of water supply and sewage networks",
        "Electrical and telecommunication cable trenching",
        "Earthworks, excavation, and soil stabilization",
        "Concrete foundations, paving, and retaining walls",
        "Underground utility infrastructure",
        "Adherence to Saudi infrastructure codes and regulations"
      ],
      customizedHeading: "Why Choose Etihad Gharbia for Infrastructure Projects",
      customizedItems: [
        "Proven experience with government-funded infrastructure contracts",
        "Fleet of modern machinery and equipment for large-scale projects",
        "In-house engineers and certified technicians",
        "Comprehensive project planning and risk mitigation",
        "Focus on sustainability, safety, and regulatory compliance",
        "Integrated approach to civil, electrical, and mechanical works",
        "Strong partnerships with suppliers and consultants",
        "Transparent communication and timely project delivery aligned with Vision 2030"
      ]
    },
    sa: {
      heading: "بنيتنا التحتية",
      buttonText: "تواصل معنا",
      aboutHeading: "حول خدمات البنية التحتية لدينا",
      aboutText: `في شركة اتحاد غربيا للمقاولات، نحن ملتزمون بتشكيل مستقبل المملكة العربية السعودية من خلال تطوير بنية تحتية عالمية المستوى. يقدم قسم البنية التحتية لدينا حلول هندسة مدنية حيوية تدعم النمو الحضري والتوسع الصناعي والربط الإقليمي.

من الطرق والجسور إلى شبكات المياه وأنظمة المرافق، ننفذ مشاريع معقدة بدقة وسلامة واستدامة. يتعاون فريق الخبراء لدينا مع الهيئات الحكومية والعملاء الخاصين لضمان تسليم البنية التحتية الأساسية لرؤية المملكة 2030 في الوقت المحدد وضمن الميزانية.`,
      includedHeading: "ما المدرج في خدمات البنية التحتية لدينا",
      includedItems: [
        "بناء الطرق السريعة والطرق والجسور",
        "تطوير أنظمة تصريف مياه الأمطار والصرف الصحي",
        "تركيب شبكات إمدادات المياه وشبكات الصرف الصحي",
        "حفر الخنادق للكابلات الكهربائية والاتصالات",
        "أعمال الحفر والتنقيب وتثبيت التربة",
        "أساسات خرسانية ورصف وجدران استنادية",
        "بنية تحتية للمرافق تحت الأرض",
        "الالتزام بأكواد البنية التحتية السعودية واللوائح"
      ],
      customizedHeading: "لماذا تختار اتحاد غربيا لمشاريع البنية التحتية",
      customizedItems: [
        "خبرة مثبتة في عقود البنية التحتية الممولة من الحكومة",
        "أسطول من الآلات والمعدات الحديثة للمشاريع الكبيرة",
        "مهندسون وفنيون معتمدون داخل الشركة",
        "تخطيط شامل للمشاريع وتخفيف المخاطر",
        "التركيز على الاستدامة والسلامة والامتثال للوائح",
        "نهج متكامل للأعمال المدنية والكهربائية والميكانيكية",
        "شراكات قوية مع الموردين والمستشارين",
        "اتصال شفاف وتسليم المشاريع في الوقت المحدد بما يتماشى مع رؤية 2030"
      ]
    },
    fr: {
      heading: "Notre infrastructure",
      buttonText: "Contactez-nous",
      aboutHeading: "À propos de nos services d'infrastructure",
      aboutText: `Chez Etihad Gharbia Contracting Company, nous nous engageons à façonner l'avenir de l'Arabie Saoudite grâce à un développement d'infrastructure de classe mondiale. Notre division infrastructure fournit des solutions de génie civil essentielles qui soutiennent la croissance urbaine, l'expansion industrielle et la connectivité régionale.

Des routes et ponts aux réseaux d'eau et systèmes utilitaires, nous exécutons des projets complexes avec précision, sécurité et durabilité à l'esprit. Nos équipes d'experts collaborent avec les organismes gouvernementaux et les clients privés pour assurer une livraison ponctuelle et respectueuse du budget des infrastructures essentielles à la Vision 2030 du Royaume.`,
      includedHeading: "Ce qui est inclus dans nos services d'infrastructure",
      includedItems: [
        "Construction d'autoroutes, routes et ponts",
        "Développement de systèmes d'eaux pluviales et de drainage",
        "Installation de réseaux d'approvisionnement en eau et d'égouts",
        "Tranchée pour câbles électriques et de télécommunication",
        "Terrassement, excavation et stabilisation des sols",
        "Fondations en béton, pavage et murs de soutènement",
        "Infrastructure utilitaire souterraine",
        "Conformité aux codes et réglementations d'infrastructure saoudienne"
      ],
      customizedHeading: "Pourquoi choisir Etihad Gharbia pour les projets d'infrastructure",
      customizedItems: [
        "Expérience avérée avec les contrats d'infrastructure financés par le gouvernement",
        "Flotte de machines et équipements modernes pour les grands projets",
        "Ingénieurs et techniciens certifiés en interne",
        "Planification de projet complète et atténuation des risques",
        "Concentration sur la durabilité, la sécurité et la conformité réglementaire",
        "Approche intégrée des travaux civils, électriques et mécaniques",
        "Partenariats solides avec les fournisseurs et consultants",
        "Communication transparente et livraison de projet rapide alignée sur la Vision 2030"
      ]
    },
    de: {
      heading: "Unsere Infrastruktur",
      buttonText: "Kontaktieren Sie uns",
      aboutHeading: "Über unsere Infrastrukturdienstleistungen",
      aboutText: `Bei der Etihad Gharbia Contracting Company setzen wir uns dafür ein, die Zukunft Saudi-Arabiens durch erstklassige Infrastrukturentwicklung zu gestalten. Unsere Infrastrukturabteilung liefert kritische Lösungen im Tiefbau, die das städtische Wachstum, die industrielle Expansion und die regionale Konnektivität unterstützen.

Von Straßen und Brücken bis hin zu Wassernetzen und Versorgungssystemen führen wir komplexe Projekte mit Präzision, Sicherheit und Nachhaltigkeit aus. Unsere Expertenteams arbeiten mit Regierungsbehörden und privaten Kunden zusammen, um eine termingerechte und budgetbewusste Lieferung der für die Vision 2030 des Königreichs wesentlichen Infrastruktur zu gewährleisten.`,
      includedHeading: "Was in unseren Infrastrukturdienstleistungen enthalten ist",
      includedItems: [
        "Bau von Autobahnen, Straßen und Brücken",
        "Entwicklung von Regenwasser- und Entwässerungssystemen",
        "Installation von Wasserversorgungs- und Abwassernetzen",
        "Graben für elektrische und telekommunikative Kabel",
        "Erdarbeiten, Aushub und Bodenstabilisierung",
        "Betonfundamente, Pflasterung und Stützmauern",
        "Unterirdische Versorgungsinfrastruktur",
        "Einhaltung saudischer Infrastrukturvorschriften und -bestimmungen"
      ],
      customizedHeading: "Warum Etihad Gharbia für Infrastrukturprojekte wählen",
      customizedItems: [
        "Bewährte Erfahrung mit staatlich finanzierten Infrastrukturverträgen",
        "Flotte moderner Maschinen und Geräte für Großprojekte",
        "Eigene Ingenieure und zertifizierte Techniker",
        "Umfassende Projektplanung und Risikominderung",
        "Fokus auf Nachhaltigkeit, Sicherheit und regulatorische Compliance",
        "Integrierter Ansatz für zivile, elektrische und mechanische Arbeiten",
        "Starke Partnerschaften mit Lieferanten und Beratern",
        "Transparente Kommunikation und termingerechte Projektlieferung im Einklang mit Vision 2030"
      ]
    }
  };

  const t = translations[language] || translations.gb;

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
        language={language}
      />
      <ServicesSubPages
        aboutHeading={t.aboutHeading}
        aboutText={t.aboutText}
        images={[Rimg1, Rimg2, Rimg3]}
        includedHeading={t.includedHeading}
        includedItems={t.includedItems}
        customizedHeading={t.customizedHeading}
        customizedItems={t.customizedItems}
      />
      <ServicesCard showHeading={false} showParagraph={false} />
      <FaqSection />
    </>
  );
};

export default Infrastructure;